import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { MasterSponsorship } from "@/types/sponsorship";

interface RemoveSponsorshipDialogProps {
  sponsorship: MasterSponsorship | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
}

export const RemoveSponsorshipDialog: React.FC<RemoveSponsorshipDialogProps> = ({
  sponsorship,
  open,
  onOpenChange,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Remove sponsorship</DialogTitle>
        <DialogDescription>
          Removing {sponsorship?.invitedEmail ?? "this person"} will end their sponsorship.
          This does not remove org or project access; review access separately. This frees up your sub-account slot.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="destructive" onClick={() => void onConfirm()}>
          Remove
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
